import { UserContext } from '@/components';
import BookmarkSimpleFill from '@/assets/bookmark-simple-fill.svg';
import { memo, useContext, useState } from 'react';
import classNames from 'classnames';

type ImageLibraryTagsProps = {
  tags?: string[];
  className?: string;
};

const ImageLibraryTags = (data: ImageLibraryTagsProps) => {
  const { tags, className } = data;
  const [tagsVisible, setTagsVisible] = useState(false);
  const { userId } = useContext(UserContext);

  /* Display tags for Lee only */
  if (userId !== '8bb66842-92bd-4932-894c-5d2a9b728f9d' || !tags || tags.length === 0) return null;

  return (
    <div className={classNames('absolute right-2 bottom-2 w-full max-w-[300px] pl-4 text-right', className)}>
      {tagsVisible && (
        <div className="relative">
          <div className="absolute right-0 bottom-0 rounded-2xl bg-white p-2 text-left text-sm">{tags?.join(', ')}</div>
        </div>
      )}
      <button
        className="cursor-pointer rounded-full bg-white p-1 shadow-md"
        onClick={(e) => {
          e.stopPropagation();
          setTagsVisible(!tagsVisible);
        }}
      >
        <BookmarkSimpleFill className="h-6 w-6 fill-black" />
      </button>
    </div>
  );
};

export default memo(ImageLibraryTags);
